import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiGit,
  DiLaravel,
  DiPhp,
  DiMysql,
  DiDocker,
  DiJira,
  DiJqueryLogo,
  DiCss3,
  DiHtml5,
  DiWordpress,
  DiBitbucket,
  DiSqllite,
} from "react-icons/di";
import {
  SiRedis,
  SiPostgresql,
  SiTailwindcss,
  SiCypress,
} from "react-icons/si";

const techItems = [
  { icon: <DiPhp />,          label: "PHP"         },
  { icon: <DiLaravel />,      label: "Laravel"     },
  { icon: <DiMysql />,        label: "MySQL"       },
  { icon: <DiJavascript1 />,  label: "JavaScript"  },
  { icon: <DiNodejs />,       label: "Node.js"     },
  { icon: <DiReact />,        label: "React"       },
  { icon: <DiDocker />,       label: "Docker"      },
  { icon: <DiMongodb />,      label: "MongoDB"     },
  { icon: <DiJqueryLogo />,   label: "jQuery"      },
  { icon: <DiGit />,          label: "Git"         },
  { icon: <DiJira />,         label: "Jira"        },
  { icon: <SiRedis />,        label: "Redis"       },
  { icon: <SiPostgresql />,   label: "PostgreSQL"  },
  { icon: <DiCss3 />,         label: "CSS3"        },
  { icon: <DiHtml5 />,        label: "HTML5"       },
  { icon: <DiWordpress />,    label: "WordPress"   },
  { icon: <DiBitbucket />,    label: "Bitbucket"   },
  { icon: <DiSqllite />,      label: "SQLite"      },
  { icon: <SiTailwindcss />,  label: "Tailwind"    },
  { icon: <SiCypress />,      label: "Cypress"     },
];

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {techItems.map(({ icon, label }) => (
        <Col key={label} xs={4} md={2} className="tech-icon-col">
          <div className="tech-icons" title={label}>
            {icon}
            <p className="tech-icon-label">{label}</p>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
